import React from 'react'
import UploadGroupBuilder from '../../UploadGroupBuilder/UploadGroupBuilder'
import clsx from "clsx"

export default class BedroomPresenterImageGroup extends React.Component {

  constructor(props) {
    super(props)
  }

  render() {
    var tabClasses = clsx({
      'active': this.props.active_tab == 'images',
      'tab-pane': true
    })

    return (
      <div className={tabClasses} id="images">
        <div className="row">
          <div className="col-md-12">
            <UploadGroupBuilder upload_type="image" upload_type_plural="images" upload_groups={this.props.image_group ? [this.props.image_group] : [{ images: [] }]} read_only={true} helperText="images_helper_text"/>
          </div>
        </div>
      </div>  
    )
  }
}